import { render, staticRenderFns } from "./_tabPayments.vue?vue&type=template&id=3bc4c644&"
import script from "./_tabPayments.vue?vue&type=script&lang=js&"
export * from "./_tabPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports